import { makeStyles } from '@material-ui/core/styles';
import typography from '@/theme/typography';
import { TextColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  root: {
    '& $heading, $info, $locationPublication, $downloadIcon': {
      color: TextColors.light,
    },

    '& $heading': {
      ...typography.h2,
    },

    '& $separator': {
      color: hexToRGBA(TextColors.light, TextOpacities.light3),
    },
  },
};

const lightTheme = {
  root: {
    '& $heading, $info, $locationPublication, $downloadIcon': {
      color: TextColors.dark,
    },

    '& $heading': {
      ...typography.h2,
    },

    '& $separator': {
      color: hexToRGBA(TextColors.dark, TextOpacities.dark3),
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
    },
    heading: {},
    description: {
      margin: muiTheme.spacing(1, 0, 2),
    },
    separator: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '18px',
      padding: '0 12px',
    },
    info: {
      display: 'flex',
      alignItems: 'center',
      alignContent: 'center',
      marginTop: '8px',
      marginBottom: '18px',
    },
    locationPublication: {
      '&.MuiTypography-root': {
        paddingLeft: '0',
      },
    },
    downloadIcon: {
      display: 'flex',
      '& img': {
        width: '20px',
        height: '20px',
      },
    },
  }),
  { name: 'GenPressReleaseHeader' },
);

export default useStyles;
